/** Convertibles page copy. EN mirrors SV until translated. */
export const pagesConvertiblesSv = {
    sections: {
        about: 'Om konvertibellånet',
        events: 'Händelser',
        other: 'Övrigt',
    },
    status: {
        label: 'Status',
        repaid: 'Återbetalt lån',
        unusedCreditLine: 'Onyttjad kreditfacilitet',
        outstandingLoan: 'Utestående lån',
    },
    creditLine: 'Kreditfacilitet',
    loanAmount: 'Lånebelopp',
    maturityDate: 'Förfallodatum',
    convertAnytime: 'Konvertering kan ske när som helst fram till förfallodagen',
    noncashConsideration: 'Apportegendom',
    interest: {
        arrangementFee: 'Uppläggningsavgift',
        monthly: 'Månadsränta',
        annual: 'Årsränta',
        label: 'Ränta',
        interestFree: 'Räntefritt',
        stiborPlus: 'STIBOR + ',
    },
    conversionPrice: {
        label: 'Konverteringskurs',
    },
    advisors: {
        financial: 'Finansiella rådgivare',
        legal: 'Legala rådgivare',
    },
    events: {
        activity: 'Aktivitet',
        conversionPrice: 'Konverteringskurs',
        empty: 'Inga händelser för konvertibeln är registrerade',
    },
    investors: {
        share: 'Andel',
        unnamed: 'Ej namngiven',
        incompleteInfo:
            'Fullständig information angående investerare och vilka belopp har ej kommunicerats av bolaget.',
    },
    lendersReceivedWarrants: 'Långivare erhöll teckningsoptioner',
}
